/**
 * Adaptador de auth — agora usa MSAL.js diretamente (Day 4 do Sprint 1).
 *
 * Antes usava `/.auth/me` do SWA Easy Auth, mas como o frontend chama o
 * Function App standalone (cross-origin), o header SWA não é injetado.
 * Solução: MSAL.js no frontend + JWT Bearer no backend.
 *
 * Esta camada existe pra apresentar a mesma interface `UsuarioLogado` que
 * o resto do código já usa, encapsulando MSAL.
 */

import { getActiveAccount, login as msalLogin, logout as msalLogout } from './msal.js';

export interface UsuarioLogado {
  email: string;
  nome: string;
  papeis: string[];
  objectId: string;
}

export function getUsuarioLogado(): UsuarioLogado | null {
  const account = getActiveAccount();
  if (!account) return null;
  // idTokenClaims tem roles, name, oid quando o token foi emitido com esses claims
  const claims = (account.idTokenClaims ?? {}) as {
    name?: string;
    oid?: string;
    roles?: string[];
  };
  return {
    email: account.username,
    nome: claims.name ?? account.name ?? account.username,
    papeis: claims.roles ?? [],
    objectId: claims.oid ?? account.localAccountId,
  };
}

/** Dispara login interativo via redirect. */
export async function entrar(): Promise<void> {
  await msalLogin();
}

/** Logout via redirect. */
export async function sair(): Promise<void> {
  await msalLogout();
}
